<template>
  <v-layout row wrap v-if="!user.premium && enableAds">
    <v-flex xs12>
      <AdViewInner :id="id" />
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import AdViewInner from "@/components/AdViewInner";

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  components: {
    AdViewInner,
  },
  computed: {
    ...mapGetters({
      user: "user/getUser",
    }),
    enableAds() {
      return process.env.VUE_APP_ENABLE_ADS === "true";
    },
  },
  methods: {
    ...mapActions({
      initUser: "user/initUser",
    }),
  },
  async mounted() {
    await this.initUser();
  },
};
</script>
